module.exports = __webpack_public_path__ + "21043a23198d922e0dfc0cf44ee52007.svg";